import {IParamGroup, ITemplate, ITestABSpec} from "services-comun-meteored/modules/services/cmp/web/resources";

export class TestABSpec {
    /* STATIC */
    public static build(data: ITestABSpec): TestABSpec {
        return new TestABSpec(data);
    }

    /* INSTANCE */
    private constructor(private readonly _data: ITestABSpec) {
    }

    private get data(): ITestABSpec {
        return this._data;
    }

    public get config(): string {
        return this.data.c;
    }

    public get name(): string {
        return this.data.n;
    }

    public get start_range(): number {
        return this.data.sr;
    }

    public get end_range(): number {
        return this.data.er;
    }

    public get template(): NodeJS.Dict<ITemplate>|undefined {
        return this.data.t;
    }

    public get param_groups(): NodeJS.Dict<IParamGroup>|undefined {
        return this.data.pg;
    }
}
